import type { IgfdPaymentPlan } from "api-types";

/**
 * Definitions of the different plans available to restaurants.
 */

// Free plan
// When restaurants are created by default, this is the plan that is assigned.
// This is also defined in igfdmobile.schemas (golang). Needs to be manually kept in sync.
export const BasicPlan: IgfdPaymentPlan = {
  numMenus: 1,
  numLocations: 1,
  numUsers: 1,
  branding: false,
  analytics: false,
  menuFiltering: false,
  products: false,
};

// Paid plans
// Set manually on a per restaurant bases via the PaymentPlan collection in firestore
// This is done via the kitchen app.

// Before we had a payment plan system, we already had restaurants on the platform.
// These flags apply to them, unless otherwise overriden by the values provided in
// the PaymentPlan collection in firestore (kitchen app).
export const GrandfatheredPlan: IgfdPaymentPlan = {
  numMenus: Infinity,
  numLocations: 1,
  numUsers: 1,
  branding: true,
  analytics: false,
  menuFiltering: true,
  products: false,
};
